import { COMPUTATION_FOR_CARPET, PAD_SF_RETAIL } from './constants';

export const calculateEstimatedTotal = (coverage, sqFtPrice) => {
  const sfWithComputation = coverage + (coverage * COMPUTATION_FOR_CARPET);
  return parseInt((sfWithComputation * sqFtPrice) + (sfWithComputation * PAD_SF_RETAIL), 10);
};

export const roundUpEstimatedTotal = (total) => {
  if (total < 100) return total;
  const roundToNearestVal = total < 1000 ? 50 : 100;
  const roundedPrice = Math.round(total / roundToNearestVal) * roundToNearestVal;

  if (roundedPrice >= total) return roundedPrice;
  return roundedPrice + roundToNearestVal;
};